import dynamicHydrate from '../../dynamic-hydration/dynamic-hydrate'
import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react'
import { useStore } from '../store'
import router from 'next/router'

const MiniCart = dynamicHydrate(() => import('@bluheadless/ui/src/organisms/minicart'), { on: ['idle'] })

const MiniCartContext = createContext()

const noop = () => {}

const MiniCartProvider = ({ children }) => {
	const [open, setOpen] = useState(false)
	const { code: storeCode } = useStore()

	const contextValue = useMemo(() => ({ open, setOpen }), [open])

	const closeMinicart = useCallback(() => {
		setOpen(false)
	}, [])

	useEffect(() => {
		router.events.on('routeChangeStart', closeMinicart)
		return () => {
			router.events.off('routeChangeStart', closeMinicart)
		}
	}, [closeMinicart])

	return (
		<MiniCartContext.Provider value={contextValue}>
			{!!storeCode && <MiniCart onClose={closeMinicart} onOpen={noop} open={open} forceHydration={open} />}
			{children}
		</MiniCartContext.Provider>
	)
}

export default MiniCartProvider

export const useMiniCartContext = () => {
	const minicartContextValue = useContext(MiniCartContext)

	if (!minicartContextValue) {
		console.warn(
			`MiniCart context value is missing. Verify that MiniCartProvider is a parent of the current component.`
		)
	}

	return minicartContextValue
}
